import { all, fork } from 'redux-saga/effects';
import { mainSaga } from './sagas/main-saga';

export function* subscriptionSagas(): Generator {
  yield all([fork(mainSaga)]);
}
